var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"createNews-wrapper"},[_c('Ckedtor',{attrs:{"newsProps":_vm.news,"isEdit":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }